import { Name } from '@shared/interfaces/name.interface';
import { FullNameWithTitle } from '@wtax/data-angular';

export const mapName = (name?: FullNameWithTitle): Name => ({
  title: name?.title,
  firstName: name?.first_name,
  lastName: name?.last_name,
});
